/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelOrderPayables.ts                 *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/settlement/order-payables";

export class AutogenModelOrderPayables<RowType extends ModelRow> extends Endpoint<RowType, RowOrderPayablesFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowOrderPayables extends ModelRow<RowOrderPayablesFields> {
	constructor(values?: Partial<RowOrderPayablesFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowOrderPayablesFields {
	accrual_date: Date;
	accrual_type: string;
	addl_revenue_code: string;
	bill_of_lading_no: string;
	billed_distance: number;
	billed_distance_um: string;
	carrier_extra_pay: number;
	carrier_extra_pay_c: string;
	carrier_extra_pay_d: Date;
	carrier_extra_pay_n: number;
	carrier_extra_pay_r: number;
	carrier_pay: number;
	carrier_pay_c: string;
	carrier_pay_d: Date;
	carrier_pay_n: number;
	carrier_pay_r: number;
	carrier_pro_nbr: string;
	check_number: string;
	commissionable_margin: number;
	commissionable_margin_c: string;
	commissionable_margin_d: Date;
	commissionable_margin_n: number;
	commissionable_margin_r: number;
	commodity_id: string;
	company_id: string;
    cutoff_date: Date;
	delivery_date: Date;
	destination_city: string;
	destination_state: string;
	driver_id: string;
	driver_name: string;
	external_invoiceno: string;
	fuel_pay: number;
	fuel_pay_c: string;
	fuel_pay_d: Date;
	fuel_pay_n: number;
	fuel_pay_r: number;
	fuel_rate: number;
	hold_comments: string;
	hubtran_approved_inv_date: Date;
	id: string;
	invoice_recv_date: Date;
	invoice_status_reason: string;
	is_commission: string;
	is_intercompany: string;
	linehaul_charge: number;
	linehaul_charge_c: string;
	linehaul_charge_d: Date;
	linehaul_charge_n: number;
	linehaul_charge_r: number;
	loaded: string;
	loadpay_process_date: Date;
	loadpay_pymt_id: string;
	loadpay_pymt_status: string;
	loadpay_transaction_date: Date;
	loadpay_transaction_num: string;
	manifest_id: string;
	movement_id: string;
	movement_seq: number;
	movement_type: string;
	ok2pay_date: Date;
	order_id: string;
	order_move_dist: number;
	order_move_dist_um: string;
	order_pay: number;
	order_pay_c: string;
	order_pay_d: Date;
	order_pay_n: number;
	order_pay_r: number;
	order_tot_dist: number;
	order_tot_dist_um: string;
	order_type: string;
	orig_posted_pay: number;
	orig_posted_pay_c: string;
	orig_posted_pay_d: Date;
	orig_posted_pay_n: number;
	orig_posted_pay_r: number;
	origin_city: string;
	origin_state: string;
	other_charges: number;
	other_charges_c: string;
	other_charges_d: Date;
	other_charges_n: number;
	other_charges_r: number;
	pay_distance: number;
	pay_distance_um: string;
	pay_method: string;
	pay_rate: number;
	payee_id: string;
	payee_type: string;
	perdiem_pay: number;
	perdiem_pay_c: string;
	perdiem_pay_d: Date;
	perdiem_pay_n: number;
	perdiem_pay_r: number;
	post_key: string;
	post_module: string;
	preload_charge: number;
	preload_charge_c: string;
	preload_charge_d: Date;
	preload_charge_n: number;
	preload_charge_r: number;
	pro_nbr: string;
	process_status: string;
	prorated_revenue: number;
	prorated_revenue_c: string;
	prorated_revenue_d: Date;
	prorated_revenue_n: number;
	prorated_revenue_r: number;
	ready_to_pay_flag: string;
	revenue_id: string;
	settle_trip_no: string;
	ship_date: Date;
	total_pay: number;
	total_pay_c: string;
	total_pay_d: Date;
	total_pay_n: number;
	total_pay_r: number;
	tractor_id: string;
	trailer_id: string;
	trailer_rent_pct: number;
	transfer_date: Date;
	trip_number: string;
	triumphpay_carrierpay_date: Date;
	triumphpay_confirm_code: string;
	triumphpay_invoice_status: string;
	triumphpay_process_date: Date;
	triumphpay_pymt_details: string;
	triumphpay_pymt_id: string;
	triumphpay_pymt_status: string;
	triumphpay_quickpay: string;
	triumphpay_transaction_date: Date;
	triumphpay_transaction_num: string;
	weight: number;
	weight_um: string;
}

